module.exports = __webpack_public_path__ + "static/media/p15.70752101.csv";